import { render, staticRenderFns } from "./djgGoods.vue?vue&type=template&id=13e561e0&scoped=true&"
import script from "./djgGoods.vue?vue&type=script&lang=js&"
export * from "./djgGoods.vue?vue&type=script&lang=js&"
import style0 from "./djgGoods.vue?vue&type=style&index=0&id=13e561e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e561e0",
  null
  
)

export default component.exports